import { render, staticRenderFns } from "./ProductViewer.vue?vue&type=template&id=267150f8&scoped=true&"
import script from "./ProductViewer.vue?vue&type=script&lang=js&"
export * from "./ProductViewer.vue?vue&type=script&lang=js&"
import style0 from "./ProductViewer.vue?vue&type=style&index=0&id=267150f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267150f8",
  null
  
)

export default component.exports